import { Sport } from './sport.models';

/** Sets the sport that corresponds to what the user is currently processing */
export class SetCurrentSport {
    public static readonly type = '[Sport] SetCurrentSport';
    constructor(public sport: Sport) { }
}

export class FetchSportConfig {
    public static readonly type = '[Sport] FetchSportConfig';
}
